import React from 'react'

import { Typography } from '@material-ui/core'
import makeStyles from '@material-ui/core/styles/makeStyles'

import { orange, white } from '../constants/colorConstants'

const useStyles = makeStyles((theme) => ({
  circle: {
    fontSize: '12.38px',
    lineHeight: '14.51px',
    color: white,
    backgroundColor: orange,
    paddingTop: '3px',
    paddingBottom: '3px',
    paddingRight: '8px',
    paddingLeft: '8px',
    borderRadius: '10px',
    ...theme.mundi.font.roboto700Normal,
  },
}))

const Exclamation = () => {
  const classes = useStyles()
  return <Typography className={classes.circle}>!</Typography>
}

export default Exclamation
